import { render, staticRenderFns } from "./HeaderPaymentsAndCurrencies.vue?vue&type=template&id=159b00f1&scoped=true&"
import script from "./HeaderPaymentsAndCurrencies.vue?vue&type=script&lang=js&"
export * from "./HeaderPaymentsAndCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPaymentsAndCurrencies.vue?vue&type=style&index=0&id=159b00f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b00f1",
  null
  
)

export default component.exports